// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module__container___iBgXu","header":"style-module__header___k5NFM","text":"style-module__text___IskNB"};